module.exports = __webpack_public_path__ + "static/media/smit_logo.3f25c44b.png";